import { Box, makeStyles } from '@material-ui/core';
import ChatSearch from '@src/components/ChatSearch';
import AdvancedSearch from '@src/components/ChatSearch/AdvancedSearch';
import StartContactConversation from '@src/components/StartContactConversation';
import { DARK_BG_CARD } from '@src/muithemes/darkModeColors';
import AboutB2ChatComponent from '@src/utils/AboutB2ChatComponent';
import { useRef } from 'react';
import CustomDivider from '../CustomDivider';
import { TRAYS_WIDTH } from '../Layout/Utils';
import B2ChatLogoWrapper from './B2ChatLogo';
import ChatTraySection from './ChatTraySection';
import { ChatTraySelectionTabs } from './ChatTraySelectionTabs';

const ChatTraysSection: React.FC = () => {
  const { container, aboutB2Chat, startConversationContainer } = useStyles();
  const chatsSearchRef = useRef<HTMLDivElement>(null);

  return (
    <Box className={container}>
      <B2ChatLogoWrapper />
      <CustomDivider />
      <Box className={startConversationContainer}>
        <div style={{ width: '100%' }} ref={chatsSearchRef}>
          <ChatSearch />
        </div>
        <StartContactConversation />
      </Box>
      <ChatTraySelectionTabs />
      <AdvancedSearch />
      <Box className="ChatActionsSection" height="100%">
        <ChatTraySection chatsSearchRef={chatsSearchRef} />
      </Box>
      <Box className={aboutB2Chat}>
        <CustomDivider />
        <AboutB2ChatComponent />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    width: TRAYS_WIDTH,
    minWidth: TRAYS_WIDTH,
    backgroundColor:
      theme.palette.type === 'dark'
        ? DARK_BG_CARD
        : theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    boxShadow:
      theme.palette.type === 'dark'
        ? '0px 8px 8px 0px rgba(0,0,0,0.3)'
        : '0px 8px 8px 0px #00000014',
  },
  aboutB2Chat: {
    position: 'absolute',
    bottom: 0,
    width: TRAYS_WIDTH,
    backgroundColor:
      theme.palette.type === 'dark'
        ? DARK_BG_CARD
        : theme.palette.background.paper,
  },
  startConversationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '0 8px',
  },
}));

export default ChatTraysSection;
